import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import FormEventHandlers from '../../../../libs/utility/formeventhandlers/FormEventHandlers';
import { BUTTON_TYPE } from '../../../components/button/constants';
import Loadable from '../../../components/loadable/Loadable';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import IRSTypeFormSubmitPopup from '../irstypeformsubmitpopup/IRSTypeFormSubmitPopup';
import { RECONCILIATION_SUBMIT_POPUP_LOADING_STATES, RECONCILIATION_SUBMIT_POPUP_STATES_MESSAGE_MAP,RECONCILIATION_FORM_NAMES } from './constants';
import { getReconciliationFormsPreloadedData, onDependentFieldChangeGetValues, saveReconciliation } from './ReconciliationFormSubmitPopupSaga';
import { componentKey, setOnDependentFields, setSuccessfullySubmittedReconciliation, setTempFormFieldsList, setToCreateFormData } from './ReconciliationFormSubmitPopupSlice';

export default function ReconciliationFormSubmitPopup({
    isPopupOpen,
    title="",
    formId,
    handlePopupClose = () => {},
    onFinalSubmitCb = () => {},
    isEditModeOn,
    taxYear,
    reconciliationPayerId,
    reconciliationState,
    formRecordId = 0,
    referenceId,
    quarter,
    scheduleReconciliationDate = "",
    setScheduleReconciliationDateCb = () => {},
    stateFormName,
}){
    useGarbageCollector(componentKey);
    const { loadingState, tempFormFieldsList, toCreateFormData, formsPreLoadedData, userInteractionPopupWResponseObj, onDependentFields, successfullySubmittedReconciliation } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        
        const tempToCreateFormData = {
            selectedYear: taxYear,
            selectedPayer: {
                PayerDetailId: reconciliationPayerId,
            },
            selectedForm: {
                FormId: formId,
            },
            selectedState: reconciliationState,
        }
        dispatch(setToCreateFormData(tempToCreateFormData));
        let additionalPreloadedPayload = {};
        if(isEditModeOn){
            additionalPreloadedPayload = {
                formRecordId: formRecordId,
                isFormEditMode: isEditModeOn,
            }
        }
        
        dispatch(getReconciliationFormsPreloadedData({
            formName: tempToCreateFormData?.selectedForm?.FormId,
            payerId: tempToCreateFormData?.selectedPayer?.PayerDetailId,
            taxYear: tempToCreateFormData?.selectedYear,
            formsPreLoadedData: formsPreLoadedData,
            getFormFieldsFlag: true,
            referenceid: referenceId,
            state: reconciliationState,
            quarter: quarter,
            toCreateFormData: tempToCreateFormData,
            ...additionalPreloadedPayload,
        }));
    }, []);

    useEffect(() => {
        if (successfullySubmittedReconciliation) {
            onFinalSubmitCb();
            handlePopupClose();
            dispatch(setSuccessfullySubmittedReconciliation(false));
        }
    }, [successfullySubmittedReconciliation]);

    const handleReconciliationFormSubmit = () => {
        const validationResult = FormEventHandlers.handleNextBtnClick("", tempFormFieldsList, true, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To save form, please resolve these errors" })));
        if (validationResult) {
            const finalFormObject = tempFormFieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});
            let formData = {
                ...finalFormObject,
                ReferenceId: referenceId,
                TaxYear: taxYear,
                PayerDetailId: reconciliationPayerId,
                FormRecordId: formRecordId,
                Quarter: quarter,
                ReconciliationFormName: RECONCILIATION_FORM_NAMES.FORMNAME
            };
            if(scheduleReconciliationDate){
                formData = {
                    ...formData,
                    ScheduledDate: scheduleReconciliationDate,
                }
            }
            if(stateFormName){
                formData = {
                    ...formData,
                    StateFormName: stateFormName,
                }
            }
            dispatch(saveReconciliation({
                formData: formData,
            }));
        }
    }

    useEffect(() => {
        FormEventHandlers.updateDependentFieldsArr(tempFormFieldsList, (reverseDependencyMap) => dispatch(setOnDependentFields(reverseDependencyMap)));
    }, [tempFormFieldsList]);

    return <>
        <Loadable
            currentState={loadingState.state}
            loadingStates={[RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING]}
            isNewLoadable={true}
            messageMap={RECONCILIATION_SUBMIT_POPUP_STATES_MESSAGE_MAP}
            preserveChildMount={true}
        >
            <IRSTypeFormSubmitPopup
                title={title}
                isPopupOpen={isPopupOpen}
                onCloseCb={handlePopupClose}
                confirmationButtonProps={{
                    onConfirmationCb: () => handleReconciliationFormSubmit(),
                    confirmationButtonText: "Save",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => handlePopupClose(),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                tempFormFieldsList={tempFormFieldsList}
                toCreateFormData={toCreateFormData}
                formsPreLoadedData={formsPreLoadedData}
                userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}
                onChangeCb={(e, field) => FormEventHandlers.inputValueChange(e, field, tempFormFieldsList, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), toCreateFormData, onDependentFields, (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), true)}
                onBlurCb={(e, inputValidationResult, field) => FormEventHandlers.handleOnBlur(e, field, tempFormFieldsList, inputValidationResult, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)))}
                dropdownOnSelectCb={(name, selectedOption, field) => FormEventHandlers.handleDropDownValueChange(name, selectedOption, tempFormFieldsList, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), () => { }, true)}
                handleIRSFormSubmitCb={handleReconciliationFormSubmit}
                dispatchNotificationCb={(heading, message, variant) => addNotifications({
                    heading: heading,
                    message: message,
                    variant: TOASTER_VARIANT[variant]
                })}
                loadingState={loadingState}
                loaderLoadingStates={[RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.CONFIGURATIONS_LOADING, RECONCILIATION_SUBMIT_POPUP_LOADING_STATES.SAVE_FORM_LOADING]}
                loaderMessageMap={RECONCILIATION_SUBMIT_POPUP_STATES_MESSAGE_MAP}
            />
        </Loadable>
    </>
}